import React, { useState } from 'react';
import { CheckCircle2, Star } from 'lucide-react';
import { motion } from 'framer-motion';
const PLANS = {
  base: {
    name: 'Autonomía Total',
    subtitle: '6 tomos + 6 bonos',
    oldPrice: '$34.990',
    price: '$19.990',
    cta: 'QUIERO MI MEGAPACK',
    url: 'https://checkout.mundodigitalarg.com/cart/48219661664497:1'
  },
  pro: {
    name: 'Autonomía Total PRO',
    subtitle: '+ PRO 1 y PRO 2',
    oldPrice: '$43.990',
    price: '$29.990',
    cta: 'QUIERO EL MEGAPACK PRO',
    url: 'https://checkout.mundodigitalarg.com/cart/48219661697265:1'
  }
} as const;
export const FinalCTA = () => {
  const [selected, setSelected] = useState<'base' | 'pro'>('pro');
  return <section className="py-12 md:py-20 bg-navy text-white relative overflow-hidden" data-id="element-88">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-navy-light via-navy to-navy opacity-80" data-id="element-89"></div>

      <div className="max-w-3xl mx-auto px-4 relative z-10 text-center" data-id="element-90">
        <div className="flex flex-col gap-3 md:gap-4 max-w-3xl mx-auto text-left mb-6" data-id="element-91">
          {/* PRO Plan Dark - on top */}
          <button type="button" onClick={() => setSelected('pro')} className={`relative rounded-2xl p-4 md:p-5 transition-all border-2 text-left ${selected === 'pro' ? 'border-gold bg-gradient-to-r from-gold/15 to-transparent shadow-2xl shadow-gold/30' : 'border-white/15 bg-navy-light/50 hover:border-gold/40'}`} aria-pressed={selected === 'pro'} data-id="element-92">
            <div className={`absolute -top-2.5 left-4 md:left-6 font-black px-2.5 md:px-3 py-1 rounded-full text-[9px] md:text-xs whitespace-nowrap shadow-lg flex items-center gap-1 ${selected === 'pro' ? 'bg-gold text-navy' : 'bg-white/10 text-gray-400'}`} data-id="element-93">
              <Star className="w-2.5 h-2.5 md:w-3 md:h-3 fill-current" data-id="element-94" /> MÁS
              ELEGIDA
            </div>

            <div className="flex items-center gap-3 md:gap-4" data-id="element-95">
              <div className={`flex-shrink-0 w-6 h-6 md:w-7 md:h-7 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'pro' ? 'border-gold bg-gold' : 'border-white/30 bg-transparent'}`} data-id="element-96">
                {selected === 'pro' && <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-navy" data-id="element-97" />}
              </div>

              <div className="flex-grow min-w-0" data-id="element-98">
                <h3 className="text-sm md:text-lg font-bold text-white leading-tight" data-id="element-99">
                  {PLANS.pro.name}
                </h3>
                <p className={`text-[11px] md:text-sm font-medium ${selected === 'pro' ? 'text-gold' : 'text-gray-400'}`} data-id="element-100">
                  {PLANS.pro.subtitle}
                </p>
              </div>

              <div className="flex-shrink-0 text-right" data-id="element-101">
                <div className="text-gray-400 line-through text-[11px] md:text-sm font-bold" data-id="element-102">
                  {PLANS.pro.oldPrice}
                </div>
                <div className="text-xl md:text-3xl font-black text-white leading-none" data-id="element-103">
                  {PLANS.pro.price}
                </div>
              </div>
            </div>
          </button>

          {/* Base Plan Dark */}
          <button type="button" onClick={() => setSelected('base')} className={`relative rounded-2xl p-4 md:p-5 transition-all border-2 text-left ${selected === 'base' ? 'border-white bg-white/10 shadow-xl' : 'border-white/15 bg-navy-light/50 hover:border-white/30'}`} aria-pressed={selected === 'base'} data-id="element-104">
            <div className="flex items-center gap-3 md:gap-4" data-id="element-105">
              <div className={`flex-shrink-0 w-6 h-6 md:w-7 md:h-7 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'base' ? 'border-gold bg-gold' : 'border-white/30 bg-transparent'}`} data-id="element-106">
                {selected === 'base' && <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-navy" data-id="element-107" />}
              </div>

              <div className="flex-grow min-w-0" data-id="element-108">
                <h3 className="text-sm md:text-lg font-bold text-white leading-tight" data-id="element-109">
                  {PLANS.base.name}
                </h3>
                <p className="text-[11px] md:text-sm text-gray-400 font-medium" data-id="element-110">
                  {PLANS.base.subtitle}
                </p>
              </div>

              <div className="flex-shrink-0 text-right" data-id="element-111">
                <div className="text-gray-500 line-through text-[11px] md:text-sm font-bold" data-id="element-112">
                  {PLANS.base.oldPrice}
                </div>
                <div className="text-xl md:text-3xl font-black text-white leading-none" data-id="element-113">
                  {PLANS.base.price}
                </div>
              </div>
            </div>
          </button>
        </div>

        {/* Shared CTA */}
        <motion.a key={selected} initial={{
        scale: 0.98,
        opacity: 0.8
      }} animate={{
        scale: 1,
        opacity: 1
      }} href={PLANS[selected].url} target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-gold hover:bg-gold-light text-navy font-black py-4 md:py-5 rounded-xl transition-colors shadow-[0_0_30px_rgba(212,162,76,0.5)] active:scale-[0.98] text-base md:text-lg" data-id="element-114">
          💥 {PLANS[selected].cta} · {PLANS[selected].price}
        </motion.a>

        <div className="flex flex-wrap justify-center items-center gap-3 md:gap-6 mt-6 md:mt-8 text-[11px] md:text-sm text-gray-400 font-medium" data-id="element-115">
          <span data-id="element-116">Pago seguro</span>
          <span className="text-gray-600" data-id="element-117">·</span>
          <span data-id="element-118">Acceso en 5 min</span>
          <span className="text-gray-600" data-id="element-119">·</span>
          <span data-id="element-120">Garantía 7 días</span>
          <span className="text-gray-600" data-id="element-121">·</span>
          <span data-id="element-122">Mercado Pago</span>
        </div>
      </div>
    </section>;
};